import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Badge, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { withRouter } from 'react-router';
import swal from 'sweetalert';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import AuthService from 'core/utils/auth/auth-service';
import { startFileDownload } from 'components/ui/FileDownload/reducer';

const propTypes = {
  test: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
};

class TestItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: false
    };
  }

  toggle = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  delete = (e) => {
    this.toggle(e);

    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this test!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        const { onDelete, test: { id } } = this.props;
        onDelete(id);
      }
    });
  }

  renderStatusBadge = (status) => {
    let color;

    switch (status) {
      case 'completed':
        color = 'success';
        break;
      default:
        color = 'primary';
    }

    return (
      <Badge
        color={color}
      >
        <span className="status">{status}</span>
      </Badge>
    );
  };

  generateConsumerReport = (e) => {
    if (e) { e.preventDefault(); }
    const { startFileDownload, test: { id } } = this.props;

    startFileDownload({
      actionPath: `${process.env.REACT_APP_PUBLIC_API_URL}/consumer_reports`,
      method: 'POST',
      queryParams: {
        token: AuthService.getToken(),
        id,
      },
    });
  }

  renderAddress = (test) => {
    const { property: { address } } = test;

    return (
      <span>
        {address.street}
        <div className="city-state">
          {address.city}, {address.state.postal_code}
        </div>
      </span>
    );
  };

  renderConsumerReportLink = ({ status }) => {
    if (status !== 'completed') {
      return null;
    }

    return (
      <DropdownItem
        title="Consumer Report"
        onClick={(e) => this.generateConsumerReport(e)}
      >
        <span>Consumer Report</span>
      </DropdownItem>
    );
  };

  render() {
    const { match, test } = this.props;

    return (
      <li
        key={test.id}
        className="TestItem"
      >
        <Link
          to={`${match.url}/${test.id}/edit`}
          className="TestItem__link"
        >
          <div className="TestItem__link__details">
            <div className="test-status">
              {this.renderStatusBadge(test.status)}
            </div>
            <div className="client-info">
              <div className="client-name">{test.property.client.first_name} {test.property.client.last_name}</div>
              <div className="client-address">{this.renderAddress(test)}</div>
            </div>
          </div>
          <div className="TestItem__link__actions">
            <Dropdown isOpen={this.state.dropdownOpen} toggle={(e) => this.toggle(e)}>
              <DropdownToggle
                tag="span"
                onClick={(e) => this.toggle(e)}
                className="more"
                data-toggle="dropdown"
                aria-expanded={this.state.dropdownOpen}
              >
                <FontAwesomeIcon icon={["fal", "ellipsis-v-alt"]} />
              </DropdownToggle>
              <DropdownMenu right>
                {this.renderConsumerReportLink(test)}
                <DropdownItem
                  onClick={(e) => this.delete(e)}
                >Delete</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </Link>
      </li>
    );
  }
}

TestItem.propTypes = propTypes;

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    startFileDownload,
  }, dispatch);
};

export default connect(undefined, mapDispatchToProps)(withRouter(TestItem));



// WEBPACK FOOTER //
// ./src/features/test/TestListContainer/TestList/TestItem.js